import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    getAllDonors: null,
    getAllDonorsLoading: null,
    getAllDonorsSuccess: ["res"],
    getAllDonorsFailure: ["error"],

    getDonors: ["id"],
    getDonorsLoading: null,
    getDonorsSuccess: ["res"],
    getDonorsFailure: ["error"],

    getDonorBySfid: ["sfid", "pid"],
    getDonorBySfidLoading: null,
    getDonorBySfidSuccess: ["res"],
    getDonorBySfidFailure: ["error"],

    searchForDonor: ["values"],
    searchForDonorLoading: null,
    searchForDonorSuccess: ["res"],
    searchForDonorFailure: ["error"],

    searchActiveDonors: [
      "lastName",
      "firstName",
      "pdn",
      "email",
      "phoneNumber",
      "city",
      "state",
      "centerNum",
      "donationCenter",
    ],
    searchActiveDonorsLoading: null,
    searchActiveDonorsSuccess: ["res"],
    searchActiveDonorsFailure: ["error"],

    registerDonor: ["donor"],
    registerDonorLoading: null,
    registerDonorSuccess: ["res"],
    registerDonorFailure: ["error"],

    registerGetDonorProfile: ["id"],
    registerGetDonorProfileLoading: null,
    registerGetDonorProfileSuccess: ["res"],
    registerGetDonorProfileFailure: ["error"],

    updateDonor: ["id", "donor", "centerChanged"],
    updateDonorLoading: null,
    updateDonorSuccess: ["res"],
    updateDonorFailure: ["error"],

    inquiryDonor: ["pdn"],
    inquiryDonorLoading: null,
    inquiryDonorSuccess: ["res"],
    inquiryDonorFailure: ["error"],

    getDonorsPreferences: ["id"],
    getDonorsPreferencesLoading: null,
    getDonorsPreferencesSuccess: ["res"],
    getDonorsPreferencesFailure: ["error"],

    updateDonorsPreferences: ["id", "preferences"],
    updateDonorsPreferencesLoading: null,
    updateDonorsPreferencesSuccess: ["res"],
    updateDonorsPreferencesFailure: ["error"],

    getDonorLifetimeImpact: null,
    getDonorLifetimeImpactLoading: null,
    getDonorLifetimeImpactSuccess: ["res"],
    getDonorLifetimeImpactFailure: ["error"],

    getDonorApcStatus: ["donorSfid"],
    getDonorApcStatusLoading: null,
    getDonorApcStatusSuccess: ["res"],
    getDonorApcStatusFailure: ["error"],

    getDonorReferEarnedAmount: ["pdn"],
    getDonorReferEarnedAmountLoading: null,
    getDonorReferEarnedAmountSuccess: ["res"],
    getDonorReferEarnedAmountFailure: ["error"],

    cleanDonorsState: null,
  },
  { prefix: "DONOR_" }
);

export const DonorTypes = Types;

export default Creators;
